export enum SourceTrack {
  A = 'A',
  B = 'B',
  C = 'C',
}

export interface EventSource {
  id: number;
  creationDate: string;
  url: string;
  name: string;
  track: SourceTrack;
  lastSuccessfulRun: string | null;
  lastEventCount: number;
  consecutiveFailures: number;
  enabled: boolean;
}

export const trackItems = [
  {
    title: 'Track A',
    value: SourceTrack.A,
  },
  {
    title: 'Track B',
    value: SourceTrack.B,
  },
  {
    title: 'Track C',
    value: SourceTrack.C,
  },
];
